import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgUmbrella from '../../svg/umbrella.svg'
import { IconProps } from '../icon-props'

const UmbrellaIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgUmbrella
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-umbrella', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default UmbrellaIcon
